import createAuth0Client from '@auth0/auth0-spa-js' ;
import Auth0Client from "@auth0/auth0-spa-js/dist/typings/Auth0Client";
import { domain, clientId,audience } from '../auth_config.json'

let authenticationClient: Auth0Client | null = null;

export async function getAuthenticationClient(): Promise<Auth0Client> {
    if (authenticationClient) {
        return authenticationClient;
    }

    authenticationClient = await createAuth0Client({
        domain: domain,
        client_id: clientId,
        audience:audience
    });

    return authenticationClient as Auth0Client;
}
